import axios from "axios";

const UsermanagerService = {
  getusers: async function () {
    const requestData = {
      method: "get",
      url: "/api/users/list",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = error.response.data.error;
      throw new Error(message);
    }
  },
  addUser: async function (username, password) {
    const requestData = {
      method: "post",
      url: "/api/user/add",
      data: {
        username: username,
        password: password
      }
    };
    try {
      console.log('adding user', username);
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = error.response.data.error;
      throw new Error(message);
    }
  },
  deleteUser: async function (username){
    const requestData = {
      method: "post",
      url: "/api/user/delete",
      data: {
        username: username
      }
    };
    try {
      // console.log('deleting user', requestData);
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = error.response.data.error;
      throw new Error(message);
    }
  },
  changePwd: async function (username, password){
    const requestData = {
      method: "post",
      url: "/api/user/changepwd",
      data: {
        username: username,
        password: password,
      }
    };
    try {
      // console.log('change password', requestData);
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = error.response.data.error;
      throw new Error(message);
    }
  }
};

export default UsermanagerService;

export { UsermanagerService };
